import {
  generateGenericPDFPages,
  generatePDF,
} from '../../../helper/pdfGenerator';
import { PDFResult } from '../../../models/pdfModal';
import { FormModel } from '../../../models/questionModel';

export const generateRiskControlReport = async (
  forms: FormModel[]
): Promise<PDFResult> => {
  const allForms = forms
    .map((f) => generateGenericPDFPages(f, 'riskControl'))
    .flat();

  return await generatePDF('Risk Control Report', allForms);
};
